import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import TimePicker from 'components/time/timepicker';
import { withTranslation } from 'react-i18next';
class TimeWindow extends React.Component {
    handleEditLeft() {
        const editor = this.refs.windowOpenEditor;
        editor.show(moment(this.props.open));
    }
    handleEditRight() {
        const editor = this.refs.windowCloseEditor;
        editor.show(moment(this.props.close));
    }
    calculateFullDate(time, day) {
        let fullDate;
        if (day) {
            fullDate = day;
        }
        else {
            fullDate = this.props.open;
        }
        fullDate = moment(fullDate);
        fullDate.hours(moment(time).hours());
        fullDate.minutes(moment(time).minutes());
        return fullDate.toISOString();
    }
    handleDayChange(timeStamp) {
        this.props.onWindowOpenChange(this.calculateFullDate(this.props.open, moment(timeStamp)));
        this.props.onWindowCloseChange(this.calculateFullDate(this.props.close, moment(timeStamp)));
    }
    handleTimeOpenChange(timeStamp) {
        this.props.onWindowOpenChange(this.calculateFullDate(timeStamp));
    }
    handleTimeCloseChange(timeStamp) {
        this.props.onWindowCloseChange(this.calculateFullDate(timeStamp));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement("p", null, t('DAY')),
                React.createElement(DatePicker, { dateFormat: "YYYY-MM-DD", value: moment(this.props.open).format('YYYY-MM-DD'), minDate: new Date(1970, 0, 1), onChange: (timeStamp) => this.handleDayChange(timeStamp), className: "form-field" })),
            React.createElement(Col, { xs: 4 },
                React.createElement("p", null, t(this.props.startTimeLabel)),
                React.createElement(TimePicker, { time: moment(this.props.open).toDate(), onChange: (timeStamp) => this.handleTimeOpenChange(timeStamp) })),
            React.createElement(Col, { xs: 4 },
                React.createElement("p", null, t('CUTOFF_TIME')),
                React.createElement(TimePicker, { time: moment(this.props.close).toDate(), onChange: (timeStamp) => this.handleTimeCloseChange(timeStamp) }))));
    }
}
TimeWindow.propTypes = {
    onWindowOpenChange: PropTypes.func.isRequired,
    onWindowCloseChange: PropTypes.func.isRequired,
    startTimeLabel: PropTypes.string,
    open: PropTypes.string.isRequired,
    close: PropTypes.string.isRequired,
};
TimeWindow.defaultProps = {
    startTimeLabel: 'START_TIME',
};
export default withTranslation()(TimeWindow);
